export default __webpack_public_path__ + "static/media/bro.d6734524.png";